import { Skeleton } from 'antd';
const CustomSkeleton = () => {
  return (
    <div className="custom-skeleton">
      <div className="centered-item">
        <Skeleton.Avatar size={100} active />
      </div>
      <div className="centered-item">
        <div style={{ width: 100, marginBottom: '35px' }}>
          <Skeleton.Button block={true} active />
        </div>
      </div>
      <div style={{ marginBottom: '35px' }}>
        <Skeleton.Button block={true} active />
      </div>

      <div>
        <Skeleton.Button block={true} active />
      </div>
    </div>
  );
};

export default CustomSkeleton;
